import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { CardDivider } from '@/components/atoms/Card';

import styles from './WeightMeasurementList.module.scss';

export interface WeightMeasurementRow {
    cageId: number;
    cageName: string;
    estimatedWeight: number;
    numberOfMeasurements: number;
}

interface WeightMeasurementListProps {
    rows: WeightMeasurementRow[];
}

/** Yesterday's estimated weight and measurement count per pen, one block per pen. */
export default function WeightMeasurementList(props: WeightMeasurementListProps) {
    const { rows } = props;
    const { t } = useTranslation();

    return (
        <>
            {rows.map((row, index) => (
                <Fragment key={row.cageId}>
                    <div className={styles.pen}>
                        <div className={styles.penName}>{row.cageName}</div>
                        <dl className={styles.figures}>
                            <div className={styles.figure}>
                                <dt>{t('common.labels.weight')}</dt>
                                <dd>{`${Math.round(row.estimatedWeight)} g`}</dd>
                            </div>
                            <div className={styles.figure}>
                                <dt>{t('location.dashboard.measurements')}</dt>
                                <dd>{`${row.numberOfMeasurements}`}</dd>
                            </div>
                        </dl>
                    </div>
                    {index + 1 < rows.length && <CardDivider />}
                </Fragment>
            ))}
        </>
    );
}
